import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageEntry } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { BreakpointService } from '@libs/breakpoints';
import { BreakpointIsPipe } from '@shared/breakpoint/breakpoint-is.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { ImageTouchPointComponent } from '../../touch-point/image-touch-point/image-touch-point.component';
import { ImageComponent } from '@shared/image/image/image.component';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-image-entry',
    templateUrl: './image-entry.component.html',
    styleUrls: ['./image-entry.component.scss'],
    host: { ngSkipHydration: 'true' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, ImageComponent, ImageTouchPointComponent, AsyncPipe, TranslateSafePipe, BreakpointIsPipe]
})
export class ImageEntryComponent {
    static readonly ref: string = 'imageEntry';

    @Input()
    public data?: ImageEntry;

    constructor(public readonly breakpointService: BreakpointService) {}
}
